import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { IntelligenceDiagram } from './IntelligenceDiagram';
import { easeOutStrong } from '../../utils/motion';
export function HomeHero() {
  const scrollToWork = () => {
    document.getElementById('what-we-build')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-28" data-id="element-413" data-mp="296n5moxx0hpb">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-10 items-center" data-id="element-414" data-mp="2wuwwi59zjvnb">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOutStrong
      }} className="lg:col-span-7" data-id="element-415" data-mp="2n4bpbtg8xiss">
          <h1 className="font-heading font-extrabold text-5xl sm:text-6xl lg:text-7xl text-ink-dark leading-[1.03] tracking-tight" data-id="element-416" data-mp="3ft97zxoddhm2">
            Building Intelligence in the World
          </h1>
          <p className="mt-8 text-xl lg:text-2xl text-ink-dark/80 leading-relaxed max-w-2xl" data-id="element-417" data-mp="ov8rx6r3q7rv">
            SyNeural builds systems that help people develop sound judgment,
            researchers connect ideas, and organizations turn knowledge into
            action. We bring connected knowledge and human capability together
            to support discovery, collaboration, and better decisions.
          </p>
          <p className="mt-5 text-base lg:text-lg text-ink-muted leading-relaxed max-w-2xl" data-id="element-418" data-mp="17l77s9155562">
            Our Semantic Knowledge Platform organizes knowledge and makes its
            sources and relationships easier to explore. Our Human Capability
            Platform, including CJI and NCJI, provides frameworks for
            assessment, development, and readiness. Noetivra makes these
            resources visible and usable through an interactive workspace for
            exploration, assessment, and collaboration.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-419" data-mp="3edr6ft8f2bps">
            <button type="button" onClick={scrollToWork} className="inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-medium px-6 py-3.5 rounded-md transition-colors duration-150 shadow-sm whitespace-nowrap" data-id="element-420" data-mp="1hcbwup74fsmj">
              Explore Our Work
              <ArrowRight size={18} data-id="element-421" data-mp="1wae171lz8i4u" />
            </button>
            <a href="/contact" className="inline-flex items-center justify-center border border-navy text-navy hover:bg-surface-muted font-medium px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-422" data-mp="20axzi8iadrsk">
              Start a Conversation
            </a>
          </div>
        </motion.div>

        <div className="lg:col-span-5" data-id="element-423" data-mp="2eyizhtjv7aw9">
          <IntelligenceDiagram data-id="element-424" data-mp="2jynjhtjzenr8" />
        </div>
      </div>
    </section>;
}